<template>
    <Modal2
        v-if="visible"
        design="v3"
        class-name="bulk-note-modal"
        :show-footer="false"
        :show-title="false"
        @cancel="onCancel"
    >
        <div class="bulk-note-modal-content">
            <div class="modal-section">
                <div class="note-editor-wrapper">
                    <div class="section-title">
                        <i class="material-icons">edit_note</i>
                        <span>Not İçeriği</span>
                    </div>

                    <div class="editor-container">
                        <a-textarea
                            v-model="description"
                            :rows="8"
                            placeholder="Not içeriğini buraya yazın..."
                            :maxLength="500"
                            class="note-textarea"
                        />
                        <div class="editor-footer">
                            <div class="help-text">
                                <i class="material-icons">info_outline</i>
                                <span>Tüm seçili kişilere aynı not eklenecektir</span>
                            </div>
                            <div class="char-counter" :class="{ warning: description.length > 450, danger: description.length >= 490 }">
                                {{ description.length }} / 500
                            </div>
                        </div>
                    </div>
                </div>

                <div class="visibility-wrapper">
                    <div class="section-title">
                        <i class="material-icons">visibility</i>
                        <span>Not Görünürlüğü</span>
                    </div>

                    <div class="visibility-options">
                        <div 
                            class="visibility-card" 
                            :class="{ selected: !isPrivate }"
                            @click="isPrivate = false"
                        >
                            <div class="card-icon public-icon">
                                <i class="material-icons">public</i>
                            </div>
                            <div class="card-content">
                                <div class="card-title">Genel Not</div>
                                <div class="card-description">Tüm ekip üyeleri görebilir</div>
                            </div>
                            <div class="selection-indicator">
                                <i v-if="!isPrivate" class="material-icons">check_circle</i>
                                <i v-else class="material-icons">radio_button_unchecked</i>
                            </div>
                        </div>

                        <div 
                            class="visibility-card" 
                            :class="{ selected: isPrivate }"
                            @click="isPrivate = true"
                        >
                            <div class="card-icon private-icon">
                                <i class="material-icons">lock</i>
                            </div>
                            <div class="card-content">
                                <div class="card-title">Özel Not</div>
                                <div class="card-description">Sadece siz görebilirsiniz</div>
                            </div>
                            <div class="selection-indicator">
                                <i v-if="isPrivate" class="material-icons">check_circle</i>
                                <i v-else class="material-icons">radio_button_unchecked</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <SupsisButton @click="onCancel">İptal</SupsisButton>
                <SupsisButton primary @click="onConfirm">
                    <i class="material-icons">add_comment</i>
                    Not Ekle
                </SupsisButton>
            </div>
        </div>
    </Modal2>
</template>

<script>
import Modal2 from "@/components/common/Modal2.vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "BulkAddNoteModal",
    components: { Modal2, SupsisButton },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
    data: function () {
        return {
            description: "",
            isPrivate: false,
        };
    },
    methods: {
        onConfirm: function () {
            if (!this.description.trim()) {
                this.$message.warning("Lütfen not içeriği yazınız");
                return;
            }

            this.$emit("confirm", {
                action: "add-note",
                payload: {
                    description: this.description.trim(),
                    isPrivate: this.isPrivate,
                },
            });
            this.reset();
        },
        onCancel: function () {
            this.$emit("cancel");
            this.reset();
        },
        reset: function () {
            this.description = "";
            this.isPrivate = false;
        },
    },
};
</script>

<style lang="scss">
.bulk-note-modal {
    .custom-modal-body {
        padding: 0 !important;
    }

    .bulk-note-modal-content {
        display: flex;
        flex-direction: column;
        min-height: 500px;

        .modal-section {
            flex: 1;
            padding: 28px;
            overflow-y: auto;
            max-height: calc(80vh - 200px);
        }

        .note-editor-wrapper,
        .visibility-wrapper {
            margin-bottom: 28px;

            .section-title {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 16px;
                padding-bottom: 12px;
                border-bottom: 2px solid #e8eaed;

                .material-icons {
                    font-size: 24px;
                    color: #22272d;
                }

                span {
                    font-size: 16px;
                    font-weight: 700;
                    color: #22272d;
                    letter-spacing: 0.3px;
                }
            }
        }

        .editor-container {
            .note-textarea {
                border: 2px solid #e8eaed !important;
                border-radius: 12px !important;
                font-size: 14px !important;
                line-height: 1.6 !important;
                transition: all 0.3s ease !important;
                resize: none !important;

                &:hover {
                    border-color: #adb5bd !important;
                }

                &:focus {
                    border-color: #22272d !important;
                    box-shadow: 0 4px 12px rgba(34, 39, 45, 0.08) !important;
                }
            }

            .editor-footer {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 12px;
                padding: 0 4px;

                .help-text {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 13px;
                    color: #6c757d;

                    .material-icons {
                        font-size: 16px;
                    }
                }

                .char-counter {
                    font-size: 13px;
                    font-weight: 600;
                    color: #adb5bd;
                    transition: color 0.2s ease;

                    &.warning {
                        color: #fd7e14;
                    }

                    &.danger {
                        color: #dc3545;
                    }
                }
            }
        }

        .visibility-options {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 14px;

            .visibility-card {
                display: flex;
                align-items: center;
                gap: 14px;
                padding: 16px;
                background: white;
                border: 2px solid #e8eaed;
                border-radius: 12px;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    border-color: #22272d;
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(34, 39, 45, 0.08);
                }

                &.selected {
                    border-color: #22272d;
                    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
                    box-shadow: 0 4px 12px rgba(34, 39, 45, 0.1);
                }

                .card-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 44px;
                    height: 44px;
                    border-radius: 12px;
                    flex-shrink: 0;

                    &.public-icon {
                        background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
                        box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);

                        .material-icons {
                            font-size: 24px;
                            color: white;
                        }
                    }

                    &.private-icon {
                        background: linear-gradient(135deg, #ffc107 0%, #ffb300 100%);
                        box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);

                        .material-icons {
                            font-size: 24px;
                            color: white;
                        }
                    }
                }

                .card-content {
                    flex: 1;

                    .card-title {
                        font-size: 14px;
                        font-weight: 700;
                        color: #22272d;
                        margin-bottom: 3px;
                    }

                    .card-description {
                        font-size: 12px;
                        color: #6c757d;
                    }
                }

                .selection-indicator {
                    .material-icons {
                        font-size: 24px;
                        color: #22272d;
                    }
                }
            }
        }

        .modal-footer {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 12px;
            padding: 20px 28px;
            border-top: 2px solid #e8eaed;

            .supsis-button {
                height: 44px;
                padding: 0 24px;
                font-size: 15px;
                border-radius: 10px;
                
                .material-icons {
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
